// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {SsoActionButtonDispatchProps, SsoActionButtonOwnProps, SsoActionButtonStateProps} from "../../components/sso/SsoActionButton";
import SsoActionButton from "../../components/sso/SsoActionButton";
import {openSsoUserActivateUserModalAction} from "../../actions/modal/creators/ssoUserActivateUserActionCreator";
import * as _ from "lodash";
import type {Caller} from "../../components/QueryPage";
import {extractCaller} from "../QueryPage";
import config from "../../config/config";
import {ssoUserActivateUserAction} from "../../actions/sso/creators/ssoUserActionCreator";

const mapStateToProps = (state: StoreState, ownProps: SsoActionButtonOwnProps): SsoActionButtonStateProps => {

    const isLoading = _.get(state, `ssoUserAction.resendActivation.${ownProps.ssoUid}.isLoading`, false) ||
        _.get(state, `ssoUserAction.activateUser.${ownProps.ssoUid}.isLoading`, false) ;
    return {
        caller: extractCaller(state),
        disabled: isLoading,
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): SsoActionButtonDispatchProps => {
    return {
        onClickAction: (ssoUid: string, caller: Caller, roleIds: Array<string>) => {
            if (!_.includes(roleIds, config.superUserRole)) {

                dispatch(openSsoUserActivateUserModalAction(ssoUid));
            } else {
                dispatch(ssoUserActivateUserAction(ssoUid, caller));
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoActionButton);



// WEBPACK FOOTER //
// ./src/containers/sso/ActivateUserButton.js